import { useEffect, useState } from "react";
import Input from "./Input/Input";
import Button from "./Button/Button";
import usePostForm from "../hooks/user/usePostForm";
import { ButtonWrapper, Container } from "./styled";
import SingleSelect from "./SingleSelect/SingleSelect";
import { FORM_FIELDS, FormValues } from "./types";
import { useFormik } from "formik";
import * as Yup from "yup";
import Text from "./Text/Text";
import { FontAlign, FontSize, FontWeight } from "../utils/Fonts";

const OPTIONS = [
  { label: "Soporte", value: "Soporte" },
  { label: "Comercial", value: "Comercial" },
];
const DEFAULT = {
  name: "",
  lastName: "",
  rut: "",
  email: "",
  phone: "",
  motive: "",
  description: "",
};

export default function App() {
  const postForm = usePostForm();

  const [success, setSuccess] = useState(false);

  const validationSchema = Yup.object({
    name: Yup.string().required("Este campo es obligatorio"),
    lastName: Yup.string().required("Este campo es obligatorio"),
    rut: Yup.string().required("Este campo es obligatorio"),
    email: Yup.string()
      .email("Ingrese una dirección de correo electrónico válida")
      .required("Este campo es obligatorio"),
    phone: Yup.string().required("Este campo es obligatorio"),
    motive: Yup.string().required("Este campo es obligatorio"),
    description: Yup.string().required("Este campo es obligatorio"),
  });

  const formik = useFormik({
    initialValues: DEFAULT,
    validationSchema: validationSchema,
    onSubmit: (values: FormValues) => {
      postForm.post({
        name: values.name,
        lastName: values.lastName,
        rut: values.rut,
        email: values.email,
        phone: values.phone,
        motive: values.motive,
        description: values.description,
      });
    },
  });

  useEffect(() => {
    if (!postForm.success) return;

    formik.resetForm();
    setSuccess(true);
  }, [postForm.success]);

  const HAS_ENTITY_NAME_ERROR =
    formik.touched[FORM_FIELDS.NAME] && !!formik.errors[FORM_FIELDS.NAME];

  const HAS_ENTITY_LASTNAME_ERROR =
    formik.touched[FORM_FIELDS.LASTNAME] &&
    !!formik.errors[FORM_FIELDS.LASTNAME];

  const HAS_ENTITY_EMAIL_ERROR =
    formik.touched[FORM_FIELDS.EMAIL] && !!formik.errors[FORM_FIELDS.EMAIL];

  const HAS_ENTITY_RUT_ERROR =
    formik.touched[FORM_FIELDS.RUT] && !!formik.errors[FORM_FIELDS.RUT];

  const HAS_ENTITY_PHONE_ERROR =
    formik.touched[FORM_FIELDS.PHONE] && !!formik.errors[FORM_FIELDS.PHONE];

  const HAS_ENTITY_MOTIVE_ERROR =
    formik.touched[FORM_FIELDS.MOTIVE] && !!formik.errors[FORM_FIELDS.MOTIVE];

  const HAS_ENTITY_DESCRIPTION_ERROR =
    formik.touched[FORM_FIELDS.DESCRIPTION] &&
    !!formik.errors[FORM_FIELDS.DESCRIPTION];

  useEffect(() => {
    if (!success) return;

    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  }, [success]);

  return (
    <Container>
      <Input
        label="Nombre"
        isRequired
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.NAME, value)
        }
        value={formik.values[FORM_FIELDS.NAME]}
        width="100%"
        hasError={HAS_ENTITY_NAME_ERROR}
        messageError={formik.errors[FORM_FIELDS.NAME]}
      />
      <Input
        label="Apellido"
        value={formik.values[FORM_FIELDS.LASTNAME]}
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.LASTNAME, value)
        }
        width="100%"
        hasError={HAS_ENTITY_LASTNAME_ERROR}
        messageError={formik.errors[FORM_FIELDS.LASTNAME]}
        isRequired
      />
      <Input
        label="RUT"
        value={formik.values[FORM_FIELDS.RUT]}
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.RUT, value)
        }
        width="100%"
        hasError={HAS_ENTITY_RUT_ERROR}
        messageError={formik.errors[FORM_FIELDS.RUT]}
        isRequired
      />
      <Input
        label="Email"
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.EMAIL, value)
        }
        value={formik.values[FORM_FIELDS.EMAIL]}
        width="100%"
        hasError={HAS_ENTITY_EMAIL_ERROR}
        messageError={formik.errors[FORM_FIELDS.EMAIL]}
        isRequired
      />
      <Input
        label="Telefono"
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.PHONE, value)
        }
        value={formik.values[FORM_FIELDS.PHONE]}
        width="100%"
        hasError={HAS_ENTITY_PHONE_ERROR}
        messageError={formik.errors[FORM_FIELDS.PHONE]}
      />
      <SingleSelect
        label="Motivo"
        handleSelected={(value) =>
          formik.setFieldValue(FORM_FIELDS.MOTIVE, value)
        }
        width="100%"
        selected={formik.values[FORM_FIELDS.MOTIVE]}
        hasError={HAS_ENTITY_MOTIVE_ERROR}
        messageError={formik.errors[FORM_FIELDS.MOTIVE]}
        isRequired
        options={OPTIONS}
      />
      <Input
        label="Descripcion"
        handleChangeInput={(value) =>
          formik.setFieldValue(FORM_FIELDS.DESCRIPTION, value)
        }
        width="100%"
        value={formik.values[FORM_FIELDS.DESCRIPTION]}
        hasError={HAS_ENTITY_DESCRIPTION_ERROR}
        messageError={formik.errors[FORM_FIELDS.DESCRIPTION]}
      />

      {!success && (
        <ButtonWrapper>
          <Button
            text={postForm.isLoading ? "Enviando" : "Enviar"}
            handleClick={() => formik.submitForm()}
            disabled={postForm.isLoading}
          />
        </ButtonWrapper>
      )}

      {success && (
        <Text
          fontAlign={FontAlign.CENTER}
          fontWeight={FontWeight.FONT_MEDIUM}
          fontSize={FontSize.TEXT_SM}
          value="Su consulta ha sido enviada con éxito. En breve nos pondremos en contacto con usted"
        />
      )}
    </Container>
  );
}
